import { render, staticRenderFns } from "./leftTwo.vue?vue&type=template&id=7350d415&scoped=true"
import script from "./leftTwo.vue?vue&type=script&lang=js"
export * from "./leftTwo.vue?vue&type=script&lang=js"
import style0 from "./leftTwo.vue?vue&type=style&index=0&id=7350d415&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_66tmnsjmdpdsiqf6am2qinky4q/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350d415",
  null
  
)

export default component.exports